/** @jsxImportSource @emotion/react */
import { t as coreT } from '@lingui/core/macro';
import { Trans, useLingui } from '@lingui/react/macro';
import { BoardTypeEnum } from 'modules/core/domain/interfaces/supabase/overlay/auxiliary-types';
import { MatchEventType } from 'shared/types/match-event';
import React, { useState } from 'react';
import UDFormInput from 'ud-form/components/input';
import UDFormSelect from 'ud-form/components/select';
import UDText from 'ud-ui/components/text';
import { CustomSelect } from './custom-select';
import Row from './row';
import { MainBlock } from './styles';
import { theme } from 'styles/theme/theme';

interface IProps {
  type: BoardTypeEnum;
}

function Type(props: IProps) {
  const { t } = useLingui();
  const [type, setType] = useState(props.type);

  return (
    <MainBlock>
      <Row headerText={t`Тип табло`}>
        <UDFormSelect
          containerProps={{ style: { width: '100%' } }}
          selectComponent={CustomSelect}
          name={'type'}
          onChange={(event) => {
            setType(event?.value);
          }}
          options={getTypeOptions()}
        />
      </Row>
      <Row headerText={t`Событие`}>
        <UDFormSelect
          containerProps={{ style: { width: '100%' } }}
          selectComponent={CustomSelect}
          placeholder={t`Выберите события`}
          isDisabled={type !== 'events'}
          name={'events'}
          isMulti
          options={getEventsOptions()}
        />
      </Row>
      <Row headerText={t`Время`}>
        <UDFormInput
          containerProps={{ style: { width: '80px' } }}
          style={{ background: theme.colors.GrayF2, display: 'flex', textAlign: 'center' }}
          disabled={type !== 'events' && type !== 'carousel'}
          name={'duration'}
          type={'number'}
          placeholder={t`Длительность в секундах`}
        />
        <UDText type={'subhead'} style={{ color: theme.colors.Gray96 }}>
          <Trans>секунд</Trans>
        </UDText>
      </Row>
    </MainBlock>
  );
}

export default Type;

/**
 * Опции собираются при вызове: подпись переводится на языке момента рендера. Выбранная опция
 * целиком лежит в значениях Formik, поэтому подпись уже выбранного значения обновится только
 * при переинициализации формы.
 */
export const getTypeOptions = (): { value: BoardTypeEnum; label: string }[] => [
  { label: coreT`Статичный`, value: 'static' },
  { label: coreT`События`, value: 'events' },
  { label: coreT`Карусель`, value: 'carousel' },
  { label: coreT`Телевизор`, value: 'tv' },
];

export const getEventsOptions = (): { label: string; value: MatchEventType }[] => [
  { label: coreT`Гол`, value: 'GOAL' },
  { label: coreT`Угловой`, value: 'CORNER' },
  { label: coreT`Пас и гол`, value: 'PASS_AND_GOAL' },
  { label: coreT`Гол в свои ворота`, value: 'OWN_GOAL' },
  { label: coreT`Пенальти гол`, value: 'PENALTY_GOAL' },
  { label: coreT`Пенальти промах`, value: 'PENALTY_MISSED' },
  { label: coreT`Серия пенальти гол`, value: 'AFTER_MATCH_PENALTY_GOAL' },
  { label: coreT`Серия пенальти промах`, value: 'AFTER_MATCH_PENALTY_MISSED' },
  { label: coreT`Красная карточка`, value: 'RED_CARD' },
  { label: coreT`Желтая карточка`, value: 'YELLOW_CARD' },
  { label: coreT`Фол`, value: 'FOUL' },
  { label: coreT`Тайм-аут`, value: 'TIME_OUT' },
  { label: coreT`Замена`, value: 'REPLACEMENT' },
  { label: coreT`Защита ворот`, value: 'SAVE' },
];
